export default { sha: 'a3efec132038fd832a636ba91d8b290720aea606', buildNumber: 'undefined' }
